import React from 'react';
import { OkButtonStyle } from './OkButton.styles';
import { Check } from 'lucide-react';

interface OkButtonProps {
  onClick: () => void;
}

export const OkButton: React.FC<OkButtonProps> = ({ onClick }) => (
  <OkButtonStyle
    onClick={onClick}
    aria-label="Ok">
    <Check size={18} strokeWidth={2.5} />
  </OkButtonStyle>
);